import Swiper, { Pagination } from 'swiper'
Swiper.use([Pagination])
import creator from '../helpers/creator'
import FixScroll from '../helpers/FixScroll'
import AudioPlayer from './AudioPlayer'
import ImageSwiper from './ImageSwiper'
import Animate from './Animate'
import Parallax from './Parallax'
import FetchArt from './FetchArt'
import LazyLoadModule from './LazyImage'
import LazyVideo from './LazyVideo'
import Tutorial from "./Tutorial";

class OverlayLayer {
  constructor(id, targetId) {
    this.id = id
    this.targetId = targetId
    // this.localStore = localStorage
    // this.parent = this.localStore.getItem('parent')

    // if(localStorage.getItem('parent') != null) {
    //   this.id = `parent-${this.parent}`
    // } else {
    //   this.id = id
    // }

    this.initialize()
  }

  initialize() {
    this.bindUI()
    this.bindEvents()
    this.displayOverlay()
  }

  bindUI() {
    this.ui = {}
    this.ui.$overlay = document.querySelector(`#${this.id}.js-overlay-ancestor`)
    if (!this.ui.$overlay) {
      console.error(`Overlay ancestor not found: #${this.id}`)
      return
    }
    this.ui.$page = this.ui.$overlay.querySelector(`${this.targetId}`)
    if (!this.ui.$page) {
      console.error(`Page not found: ${this.targetId}`)
      return
    }
    this.ui.$overlayHeader = this.ui.$page.querySelector('.js-overlay-header')
    this.ui.$overlayTitle = this.ui.$page.querySelector('.js-overlay-title')
    this.ui.$overlayHeaderMini = document.querySelector('.js-overlay-header-mini')
    this.ui.$slider = this.ui.$overlay.querySelector('.js-slider')
    this.ui.$overlayInner = this.ui.$page.querySelector('.js-overlay-inner')
    this.ui.$nexts = this.ui.$page.querySelectorAll('.js-next')
    this.ui.$next = this.ui.$page.querySelector('.overlay__next')
    this.ui.$slides = this.ui.$page.parentNode.querySelectorAll('.slider__cell')
    this.ui.$index = this.ui.$page.getAttribute('data-index')
    this.ui.$pagination = this.ui.$page.querySelector('.js-pagination')
    this.ui.$dots = [...this.ui.$page.querySelectorAll('.js-pagination .dot')]
    this.ui.$close = document.querySelector('.js-overlay-close')
    this.ui.$player = this.ui.$page.querySelector('.js-player-data')
    this.ui.$audioPlayer = document.querySelector('.js-player')
    this.ui.$imageSwiper = this.ui.$page.querySelectorAll('.js-image-swiper')
    this.nextOverlay = null
    this.touchstartX = 0;
    this.touchstartY = 0;
    this.touchendX = 0;
    this.touchendY = 0;
    window.imageswiper = []
  }

  bindEvents() {
    for (let i = 0; i < this.ui.$nexts.length; i++) {
      const next = this.ui.$nexts[i];
      if (next != null) {
        next.addEventListener('click', this.onNext.bind(this))
      }
    }
  }

  displayOverlay() {
    if (!this.ui.$overlay) return

    if (this.ui.$overlay.classList.contains('is-scrolling')) {
      this.ui.$overlay.classList.remove('is-scrolling')
      this.ui.$overlay.parentNode.classList.remove('is-scrolling')
    }
    this.ui.$overlay.classList.add('is-active')
    this.ui.$overlay.classList.add('is-scrolling')
    this.ui.$overlay.parentNode.classList.add('is-scrolling')
    
    const closeButton = this.ui.$page.querySelector('.js-overlay-close')
    if (closeButton) {
      closeButton.addEventListener('click', this.onClose.bind(this))
    }

    FixScroll.fix()

    // Réinitialiser le player avant d'initialiser le nouveau
    if (window.audioplayer) {
      this.removePlayerData()
    }
    this.hidePlayer()

    window.lazyvideo.initialize()

    setTimeout(() => {
      if (this.ui.$overlayHeaderMini) {
        const headerCloseButton = this.ui.$overlayHeaderMini.querySelector('.js-overlay-close')
        if (headerCloseButton) {
          headerCloseButton.addEventListener('click', this.onClose.bind(this))
        }
      }
      
      if (this.ui.$overlay) {
        this.ui.$overlay.addEventListener('scroll', this.onScroll.bind(this))
      }

      const _that = this // sorry

      if (window.sliderdefault) {
        window.sliderdefault.update()
        
        let arts = [...window.sliderdefault.slides[window.sliderdefault.activeIndex].querySelectorAll('.js-art-link')]
        if (arts.length > 0) {
          arts.forEach(element => {
            window.fetchart = new FetchArt(element, true)
          });
        }

        window.sliderdefault.on('slideChange', function () {
          window.overlaylayer.ui.$overlay.scrollTo(0, 0);
          _that.ui.$overlayHeaderMini.innerHTML = ""
          let activeSlide = window.sliderdefault.slides[window.sliderdefault.activeIndex]
          let close = activeSlide.querySelector('.js-overlay-close')
          close.addEventListener('click', _that.onClose.bind(_that))

          let imageswipers = activeSlide.querySelectorAll('.js-image-swiper')
          if (imageswipers.length > 0) {
            imageswipers.forEach(imageSwiper => {
              window.imageswiper.push(new ImageSwiper(imageSwiper))
            });
          }

          let next = activeSlide.querySelector('.js-next')
          if (next != null) {
            next.addEventListener('click', _that.onNext.bind(_that))
          }

          let images = activeSlide.querySelectorAll('.js-parallax')
          if (images.length > 0) {
            window.parallax = new Parallax(images)
          }

          let arts = [...activeSlide.querySelectorAll('.js-art-link')]
          if (arts.length > 0) {
            arts.forEach(element => {
              window.fetchart = new FetchArt(element, true)
            });
          }

          window.animate = new Animate()

          let player = activeSlide.querySelector('.js-player-data')
          if (player != null) {
            if (window.audioplayer != undefined) {
              _that.removePlayerData()
            }
            _that.addPlayerData(player)
            _that.ui.$overlay.classList.add('has-player')
            _that.ui.$overlay.parentNode.classList.add('has-player')
          } else {
            _that.hidePlayer()
            _that.ui.$overlay.classList.remove('has-player')
            _that.ui.$overlay.parentNode.classList.remove('has-player')
          }

          let overlayClose = activeSlide.querySelector('.js-overlay-close')
          let overlayTitle = activeSlide.querySelector('.js-overlay-title')
          let overlayPagination = activeSlide.querySelector('.js-pagination')

          let overlayCloneClose = overlayClose.cloneNode(true)
          let title = overlayTitle.cloneNode(true)
          let pagination = overlayPagination.cloneNode(true)

          _that.ui.$overlayHeaderMini.append(overlayCloneClose)
          _that.ui.$overlayHeaderMini.append(title)
          _that.ui.$overlayHeaderMini.append(pagination)

          if (
            activeSlide.classList.contains('template-history') ||
            activeSlide.classList.contains('archive-artist') ||
            activeSlide.classList.contains('template-map-dark')
          ) {
            _that.ui.$overlayHeaderMini.classList.add('overlay-header-mini--dark')
          } else {
            _that.ui.$overlayHeaderMini.classList.remove('overlay-header-mini--dark')
          }

          overlayCloneClose.addEventListener('click', _that.onClose.bind(_that))

          let id = activeSlide.querySelector('.js-overlay-child').getAttribute('data-id')
          let pathUrl

          window.fetchdata.items.forEach(item => {
            if (item.id == id) {
              pathUrl = new URL(item.url)
            }
          });
        })
      }

      this.ui.$overlay.parentNode.classList.add('animate-in')
      this.ui.$overlay.parentNode.classList.remove('animate-out')
      document.body.classList.add('overlay-is-active')
      document.documentElement.classList.add('overlay-is-active')

      // if (!window.token.getCookie('tutorial-end')) {
      //   window.tutorial = new Tutorial();
      //   window.token.setCookie('tutorial-end', 1, 60)
      // }

      if (this.ui.$imageSwiper.length > 0) {
        this.ui.$imageSwiper.forEach(imageSwiper => {
          window.imageswiper.push(new ImageSwiper(imageSwiper))
        });
      }

      for (let i = 0; i < window.video.length; i++) {
        const video = window.video[i]
        if (!video.isMute) {
          video.mute()
        }
      }

      // Vérifier et initialiser le player pour le slide initial
      if (this.ui.$player != null) {
        // S'assurer que le player est visible
        this.ui.$audioPlayer.style.display = 'block'
        this.ui.$audioPlayer.classList.add('is-visible')
        
        // Ajouter les classes nécessaires
        this.ui.$overlay.classList.add('has-player')
        this.ui.$overlay.parentNode.classList.add('has-player')
        
        // Initialiser le player avec un délai pour s'assurer que le DOM est prêt
        requestAnimationFrame(() => {
          this.addPlayerData(this.ui.$player)
        })
      } else {
        this.hidePlayer()
        this.ui.$overlay.classList.remove('has-player')
        this.ui.$overlay.parentNode.classList.remove('has-player')
      }

      // Déclencher l'événement overlay:opened pour notifier les autres modules
      const event = new CustomEvent('overlay:opened', {
        detail: {
          overlay: this.ui.$overlay,
          targetId: this.targetId
        }
      })
      window.dispatchEvent(event)

    }, 300)
  }

  onNext(e) {
    let target = e.target
    if (!target.matches('.js-next')) return

    let ancestorId = target.getAttribute('data-parent-id')
    let targetId = target.getAttribute('data-target')

    if (!ancestorId || !targetId) {
      console.error('Missing required attributes: data-parent-id or data-target')
      return
    }

    // Arrêter la lecture audio avant de changer de slide
    if (window.audioplayer) {
      this.hidePlayer()
    }

    this.removeOverlay()

    setTimeout(() => {
      window.overlaylayer = new OverlayLayer(ancestorId, targetId)
      let slider = window.overlaylayer.ui.$overlay.querySelector('.js-slider')
      if (!slider) {
        console.error('Slider not found')
        return
      }
      function updateAccessibility(swiper) {
        swiper.slides.forEach((slide, index) => {
          const isActive = index === swiper.activeIndex;
          slide.setAttribute('aria-hidden', isActive ? "false" : "true");

          slide.querySelectorAll('a, button, input, select, textarea').forEach((el) => {
            el.tabIndex = isActive ? 0 : -1;
          });
          if (isActive) {
            trapFocus(slide);
          }
        });
      }

      function trapFocus(container) {
        const containerFocusableElements = container.querySelectorAll('a, button');
        const playerFocusableElements = document.querySelectorAll('.js-player-toggle, .js-player-transcript, .js-player-transcript-close');
        
        const allFocusableElements = [...containerFocusableElements, ...playerFocusableElements];        
        if (allFocusableElements.length === 0) return;

        const handleKeyDown = (e) => {
          if (e.key === 'Escape') {
            container.setAttribute('aria-hidden', "true");
            allFocusableElements.forEach((el) => {
              el.tabIndex = -1;
            });
            window.overlaylayer.onClose(container.querySelector('.js-overlay-close'));
          }
          if (e.key === 'Tab') {
            const currentIndex = Array.from(allFocusableElements).indexOf(document.activeElement);
            
            if (e.shiftKey) {
              // Tab inversé (Shift + Tab)
              if (currentIndex === 0) {
                e.preventDefault();
                allFocusableElements[allFocusableElements.length - 1].focus();
              }
            } else {
              // Tab normal
              if (currentIndex === allFocusableElements.length - 1) {
                e.preventDefault();
                allFocusableElements[0].focus();
              }
            }
          }
        };

        container.addEventListener('keydown', handleKeyDown);
        document.querySelector('.js-player').addEventListener('keydown', handleKeyDown);
        
        // Nettoyage des événements lors de la fermeture
        const cleanup = () => {
          container.removeEventListener('keydown', handleKeyDown);
          document.querySelector('.js-player').removeEventListener('keydown', handleKeyDown);
        };
        
        // Ajouter le nettoyage à la fermeture de l'overlay
        const originalOnClose = window.overlaylayer.onClose;
        window.overlaylayer.onClose = function(...args) {
          cleanup();
          return originalOnClose.apply(this, args);
        };

        allFocusableElements[0].focus();
      }
      let activeIndex = Array.from(slider.querySelectorAll('.swiper-slide')).indexOf(slider.querySelector(targetId))
      let targetSlide = slider.querySelector(targetId)
      if (!targetSlide) {
        console.error('Target slide not found:', targetId)
        return
      }
      let initialSlideIndex = targetSlide.getAttribute('data-index')
      if (!initialSlideIndex) {
        console.error('No data-index found on target slide')
        return
      }

      window.sliderdefault = new Swiper(slider, {
        on: {
          init: function () {
            setTimeout(() => {
            updateAccessibility(this);
            }, 200);
          },
          slideChange: function () {
            setTimeout(() => {
              updateAccessibility(this);
            }, 500);
          },
        },
        spaceBetween: 16,
        initialSlide: activeIndex,
        autoHeight: true,
        observer: true,
        observeParents: true,
        slidesPerView: 'auto',
        pagination: {
          el: ".js-pagination",
        }
      })

      let activeSlide = window.sliderdefault.slides[window.sliderdefault.activeIndex]
      if (!activeSlide) {
        console.error('No active slide found')
        return
      }

      window.sliderdefault.update()
      let overlayClose = activeSlide.querySelector('.js-overlay-close')
      let overlayTitle = activeSlide.querySelector('.js-overlay-title')
      let overlayPagination = activeSlide.querySelector('.js-pagination')

      let close = overlayClose.cloneNode(true)
      let title = overlayTitle.cloneNode(true)
      let pagination = overlayPagination.cloneNode(true)
      let bullets = pagination.querySelectorAll('.swiper-pagination-bullet')

      for (let i = 0; i < bullets.length; i++) {
        bullets[i].classList.remove('swiper-pagination-bullet-active')
      }

      bullets[window.sliderdefault.activeIndex].classList.add('swiper-pagination-bullet-active')

      let images = activeSlide.querySelectorAll('.js-parallax')
      if (images.length > 0) {
        window.parallax = new Parallax(images)
      }

      if (!window.location.href.includes('singleurl')) {
        let arts = [...activeSlide.querySelectorAll('.js-art-link')]
        if (arts.length > 0) {
          arts.forEach(element => {
            window.fetchart = new FetchArt(element, true)
          });
        }
      }

      if (
        activeSlide.classList.contains('template-history') ||
        activeSlide.classList.contains('archive-artist') ||
        activeSlide.classList.contains('template-map-dark')
      ) {
        this.ui.$overlayHeaderMini.classList.add('overlay-header-mini--dark')
      }

      this.ui.$overlayHeaderMini.innerHTML = ""
      this.ui.$overlayHeaderMini.append(close)
      this.ui.$overlayHeaderMini.append(title)
      this.ui.$overlayHeaderMini.append(pagination)

      let id = activeSlide.querySelector('.js-overlay-child').getAttribute('data-id')
      let pathUrl

      window.fetchdata.items.forEach(item => {
        if (item.id == id) {
          pathUrl = new URL(item.url)
        }
      });

      window.dataLayer.push({
        'event': 'page_view',
        'page_path': pathUrl.pathname,
        'page_title': title.innerText
      });

      // Déplacer le player dans le slide initial
      const audioPlayer = document.querySelector('.js-player');
      if (audioPlayer && !activeSlide.contains(audioPlayer)) {
        activeSlide.appendChild(audioPlayer);
      }

      // Vérifier et initialiser le lecteur audio pour le slide initial
      let playerData = activeSlide.querySelector('.js-player-data')
      if (playerData) {
        // Attendre que le DOM soit complètement chargé
        setTimeout(() => {
          if (window.audioplayer) {
            this.removePlayerData()
          }
          this.addPlayerData(playerData)
        }, 100)
      }
    }, 700)
  }

  onScroll(e) {
    let target = e.currentTarget
    let scrollPos = target.scrollTop
    let headerBottomPos = this.ui.$overlayHeader.offsetHeight

    window.sliderdefault.update()

    target.classList.add('is-scrolling')
    target.parentNode.classList.add('is-scrolling')

    if (scrollPos > headerBottomPos) {
      this.ui.$overlayHeaderMini.classList.add('is-visible')
    } else {
      this.ui.$overlayHeaderMini.classList.remove('is-visible')
    }
  }

  onClose(e) {
    let target = e.currentTarget || e
    if (!target.matches('.js-overlay-close')) return


    this.removeOverlay()
    window.history.replaceState(null, null, window.location.pathname);

    for (let i = 0; i < window.video.length; i++) {
      const video = window.video[i]
      if (!video.isMute) {
        video.mute()
      }
    }
  }

  removeOverlay() {
    document.querySelector('.hdr-logo-link').focus()
    if (this.ui.$overlayHeaderMini) {
      this.ui.$overlayHeaderMini.classList.remove('is-visible')
      this.ui.$overlayHeaderMini.classList.remove('overlay-header-mini--dark')
      this.ui.$overlayHeaderMini.innerHTML = ""
    }

    // Nettoyer le slider
    if (window.sliderdefault) {
      window.sliderdefault.destroy(true, true)
      window.sliderdefault = undefined
    }

    // Nettoyer le parallax
    if (window.parallax != undefined && window.parallax.els.length > 0) {
      window.parallax.instance.destroy()
      window.parallax = undefined
    }

    // Nettoyer les image swipers
    if (window.imageswiper && window.imageswiper.length > 0) {
      window.imageswiper.forEach(swiper => {
        if (swiper && swiper.destroy) {
          swiper.destroy(true, true)
        }
      })
      window.imageswiper = []
    }

    // Remettre le player à sa place d'origine
    const audioPlayer = document.querySelector('.js-player')
    if (audioPlayer) {
      const originalParent = document.querySelector('.js-overlay-ancestor')
      if (originalParent && !originalParent.contains(audioPlayer)) {
        originalParent.appendChild(audioPlayer)
      }
    }

    // Réinitialiser le scroll
    window.overlaylayer.ui.$overlay.scrollTo(0, 0)

    // Nettoyer les animations
    if (window.animate) {
      window.animate.elements.forEach(element => {
        if (!element.classList.contains('card')) {
          element.classList.remove('is-visible')
        }
      })
    }

    // Nettoyer le player
    let player = this.ui.$overlay.querySelector('.js-player-data')
    if (player != null || this.ui.$player != null) {
      this.hidePlayer()
      this.ui.$overlay.classList.remove('has-player')
      this.ui.$overlay.parentNode.classList.remove('has-player')
    }

    // Nettoyer les thumbnails
    let thumbnails = document.querySelectorAll('.thumbnail')
    for (let i = 0; i < thumbnails.length; i++) {
      thumbnails[i].classList.remove('is-animate')
    }

    // Nettoyer les classes de l'overlay
    this.ui.$overlay.parentNode.classList.remove('animate-in')
    this.ui.$overlay.parentNode.classList.add('animate-out')
    this.ui.$overlay.classList.remove('is-active')
    this.ui.$overlay.classList.remove('is-scrolling')
    this.ui.$overlay.parentNode.classList.remove('is-scrolling')

    // Réinitialiser les classes du body
    document.body.classList.remove('overlay-is-active')
    document.documentElement.classList.remove('overlay-is-active')

    // Réinitialiser le scroll
    FixScroll.unFix()

    // Déclencher l'événement overlay:closed pour notifier les autres modules
    const event = new CustomEvent('overlay:closed', {
      detail: {
        overlay: this.ui.$overlay,
        targetId: this.targetId
      }
    })
    window.dispatchEvent(event)

    // Nettoyer l'instance de l'overlay
    setTimeout(() => {
      window.overlaylayer = undefined
      this.ui.$overlayHeaderMini.innerHTML = ""
    }, 100)
  }

  addPlayerData(player) {
    try {
      let title = player.getAttribute('data-title')
      let cover = player.getAttribute('data-cover')
      let audio = player.getAttribute('data-audio')
      let transcription = player.getAttribute('data-transcription') 

      let audioPlayerTitle = this.ui.$audioPlayer.querySelector('.js-player-title')
      let audioPlayerCover = this.ui.$audioPlayer.querySelector('.js-player-cover')

      if (!audioPlayerTitle || !audioPlayerCover) {
        console.warn('Player elements not found')
        return
      }

      // S'assurer que le player est visible
      this.ui.$audioPlayer.style.display = 'block'
      this.ui.$audioPlayer.classList.add('is-visible')
      
      // Mettre à jour le contenu
      audioPlayerTitle.textContent = title
      audioPlayerCover.src = cover

      // Nettoyer l'ancien lecteur si existant
      if (window.audioplayer) {
        this.removePlayerData()
      }
      
      // Initialiser le nouveau lecteur avec getInstance
      window.audioplayer = AudioPlayer.getInstance(audio)
      
      // Ajouter les classes nécessaires
      this.ui.$overlay.classList.add('has-player')
      this.ui.$overlay.parentNode.classList.add('has-player')

      // Forcer une mise à jour de l'affichage
      requestAnimationFrame(() => {
        this.ui.$audioPlayer.style.display = 'block'
        this.ui.$audioPlayer.classList.add('is-visible')
      })

    } catch (error) {
      console.error('Error in addPlayerData:', error)
      this.hidePlayer()
    }
  }

  removePlayerData() {
    if (window.audioplayer != null) {
      try {
        // Utiliser la nouvelle méthode de réinitialisation
        AudioPlayer.resetInstance();
        window.audioplayer = null;
      } catch (error) {
        console.error('Error in removePlayerData:', error)
      }
    }
  }

  hidePlayer() {
    try {
      this.ui.$audioPlayer.style.display = 'none'
      this.ui.$audioPlayer.classList.remove('is-visible')
      
      if (window.audioplayer != undefined) {
        this.removePlayerData()
      }
      
      // Réinitialiser l'interface
      let audioPlayerTitle = this.ui.$audioPlayer.querySelector('.js-player-title')
      let audioPlayerCover = this.ui.$audioPlayer.querySelector('.js-player-cover')
      
      if (audioPlayerTitle) audioPlayerTitle.textContent = ''
      if (audioPlayerCover) audioPlayerCover.src = ''
      
      this.ui.$overlay.classList.remove('has-player')
      this.ui.$overlay.parentNode.classList.remove('has-player')
    } catch (error) {
      console.error('Error in hidePlayer:', error)
    }
  }
}

export default OverlayLayer
